import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { useState, useRef } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { PageScrollRefContext } from '../../page-doc/context';
import { PageInfo } from '../page-info';
import { PageFeedList } from './page-feed-list';
import { Icon } from 'src/common/components/icon';
import { useToggleDrawer } from '../shared';

export const enum PageFeedTabIndex {
  PAGE_INFO = 0,
  PAGE_FEED = 1,
}
let defaultIndex = PageFeedTabIndex.PAGE_INFO;
export const setPageFeedIndex = (index: PageFeedTabIndex) => {
  defaultIndex = index;
};
export const PageFeeds: FC = () => {
  const { t } = useAppTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [tabIndex, setTabIndex] = useState(defaultIndex);
  const showPageFeed = tabIndex === PageFeedTabIndex.PAGE_FEED;
  const toggleDrawer = useToggleDrawer();
  return (
    <PageScrollRefContext.Provider value={scrollRef}>
      <div className="h-full flex flex-col items-stretch">
        <div className="h-[50px] border-b border-b-grey6 text-t2-medium flex items-center justify-between">
          <div className="h-full flex items-center mx-4 space-x-7">
            <span
              className={cx(
                'cursor-pointer',
                !showPageFeed && 'underline underline-offset-[19.5px]'
              )}
              onClick={() => {
                setTabIndex(PageFeedTabIndex.PAGE_INFO);
              }}
            >
              <div className="text-base font-medium">{t('views.header.view_page_info')}</div>
            </span>
            <span
              className={cx(
                'cursor-pointer',
                showPageFeed && 'underline underline-offset-[19.5px]'
              )}
              onClick={() => {
                setTabIndex(PageFeedTabIndex.PAGE_FEED);
              }}
            >
              {t('common.page_activity')}
            </span>
          </div>
          <Icon
            className="mr-4"
            name={'IcUnfold'}
            size="middle"
            onClick={() => {
              toggleDrawer('page-feeds');
            }}
          />
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto">
          {/* display为none可以避免重建页面时发送请求 */}
          <div
            style={{
              display: showPageFeed ? 'block' : 'none',
            }}
          >
            <PageFeedList />
          </div>
          <div
            style={{
              display: !showPageFeed ? 'block' : 'none',
            }}
          >
            <PageInfo />
          </div>
        </div>
      </div>
    </PageScrollRefContext.Provider>
  );
};
